import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import { green } from '~theme';
import cancelImg from '~images/sulje_profiili.svg';
import { setProjectOrderLink } from '../features/projects/ducks';

const LinkInfo = ({ projectOrderLink }) => {
  const dispatch = useDispatch();
  const { taskName, projectName } = projectOrderLink;

  return (
    <Container>
      <Description>
        Tekemäsi tilaus liitetään tehtävään {taskName || 'Tuntematon tehtävä'}{' '}
        projektissa {projectName || 'Tuntematon projekti'}
      </Description>
      <Cancel
        src={cancelImg}
        onClick={() => dispatch(setProjectOrderLink(null))}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;

  color: white;
  padding: 8px;
  background-color: ${green};
  border-radius: 4px;
  max-width: 400px;
`;

const Description = styled.div``;

const Cancel = styled.img`
  height: 16px;
  cursor: pointer;
  margin-left: 16px;
  margin-right: 8px;
`;

export default LinkInfo;
